import React from 'react'
import { connect } from 'react-redux';

const HTML_PATH = 'static/html/CHSU_UAT_HTML5_MiniQW_package.html'

class MarketInfo extends React.Component {
  constructor(nProps) {
    super(nProps);
    nProps.innerRef(this);
    this.state = {
      rowData: [],
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
    }
    this.aastockRef = React.createRef();
  }

  componentDidMount() {
    this.loadAAstock()
  }

  loadAAstock(){
    const params = {
        uname: this.props.aastockClientId ? this.props.aastockClientId: 'uat_chsuqw',
        password: 'aastocks',
        broker: 'CHSU'
    }
    this.aastockRef.src = HTML_PATH
    setTimeout(() => this.aastockRef.contentWindow.handleSubmit(params), 100)
  }

  render() {
    const {isMobile} = this.props
    return (
      <div style={{height:isMobile ? "calc(100% + 38px)" :'100%',margin: isMobile ? "0" : '0 20px'}}>
        <iframe src={HTML_PATH} frameborder="0" ref={e => this.aastockRef = e} style={{width:'100%',height:'100%'}}></iframe>
      </div>
    )
  }

}

MarketInfo.defaultProps = {
  isFilter: false,
  autoSize: true
}

export default connect(
  state => ({
    language: state.app.language,
    aastockClientId: state.auth.aastockClientId,
    isMobile: state.app.isMobile,
  }))(MarketInfo)
